import React, { useState, VFC } from 'react';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { IconProps } from '@jbhi-fi/lanyard-ui/components/Icon/CustomIcon';
import Button from '@jbhi-fi/lanyard-ui/components/Button';
import { styles } from './HeaderUtilityButton.css';
import { useTrackingContext } from '../../../Tracking';
import { useIdPrefix } from '../../../IdPrefix';

export interface HeaderUtilityButtonProps {
  label: string;
  datalayerLabel?: string;
  datalayerValue?: string;
  icon: VFC<IconProps>;
  showOnMobile?: boolean;
  shouldShowQtyBadge?: boolean;
  badgeQty?: number;
  newCouponCount?: number | undefined;
  shouldBadgeAnimate?: boolean;
  hasSubmenu?: boolean;
  submenuComponent?: React.FC<{ onHideSubmenu: () => void }>;
  onClick?: () => void;
  customElementId?: string;
  testId?: string;
}

export const HeaderUtilityButton = ({
  label,
  datalayerLabel,
  datalayerValue,
  icon: ButtonIcon,
  showOnMobile,
  shouldShowQtyBadge,
  badgeQty = 0,
  newCouponCount,
  shouldBadgeAnimate,
  hasSubmenu,
  submenuComponent: SubmenuComponent,
  onClick,
  customElementId,
  testId,
}: HeaderUtilityButtonProps) => {
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const shouldShowSubmenu = hasSubmenu && SubmenuComponent && isSubmenuOpen;
  const { tracker } = useTrackingContext();
  const generatedId = useIdPrefix(datalayerValue);
  const id = customElementId ?? generatedId ?? undefined;
  const handleHideSubmenu = () => {
    setIsSubmenuOpen(false);
  };

  const handleClick = () => {
    tracker.trackClick({
      label: datalayerLabel,
      extraData: { group: 'Mega Nav', value: datalayerValue },
    });
    if (hasSubmenu && SubmenuComponent) {
      setIsSubmenuOpen(!isSubmenuOpen);
      // leaving this this here just so we remember to remove it should anything go wrong
      // return;
    }
    if (onClick) onClick();
  };
  return (
    <div
      className={classNames([styles.container, showOnMobile ? undefined : styles.containerNotOnMobile])}
      id={id}
      data-testid={testId}
    >
      <Button classes={styles.link} type="link" onClick={handleClick}>
        {ButtonIcon ? <ButtonIcon height="18px" className={styles.icon} /> : null}
        <span className={styles.label}>{label}</span>
      </Button>
      {shouldShowQtyBadge ? (
        <div className={classNames([styles.qtyBadge, shouldBadgeAnimate && styles.pulse])}>{badgeQty}</div>
      ) : null}
      {newCouponCount && newCouponCount > 0 ? (
        <div className={classNames([styles.newCouponCount, shouldBadgeAnimate && styles.pulse])}>{newCouponCount}</div>
      ) : null}
      {shouldShowSubmenu ? <SubmenuComponent onHideSubmenu={handleHideSubmenu} /> : null}
    </div>
  );
};
